<template>
    <div style="min-height: 400px;">
        <b-row>
            <b-col cols="auto" class="mr-auto">
            </b-col>
            <b-col cols="auto" class="">
                <b-form-group>
                    <b-button variant="github" class="mr-1 btn-brand" @click="openModal()" :disabled="totalToPay <= 0"><i class="fa fa-plus"></i><span>Novo Pagamento</span></b-button>
                </b-form-group>
            </b-col>
        </b-row>
        
        <b-table :items="items" :fields="table.fields" :select-mode="table.selectMode" responsive="sm" primary-key="id" 
                :tbody-transition-props="table.transProps" sort-icon-left
                per-page="50" current-page="1" :busy="table.isBusy" hover striped style="min-height: 200px;">

            <template #cell(show_details)="row">
                <b-row>
                    <b-col cols="auto" class="mr-auto">
                        <b-form-group>
                        <b-button size="sm" variant="primary"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                        </b-form-group>
                    </b-col>
                </b-row>
            </template>
            
            <template #row-details="row">
                <b-card>
                    <b-row v-show="row.item.mop && row.item.paymentAccountId > 0">
                        <b-col><span class="small">Conta: </span>{{ row.item.paymentAccountName }} | {{ row.item.mop ? row.item.mop.name : '' }}</b-col>
                    </b-row>
                    <b-row v-show="row.item.paymentVoucher && row.item.paymentVoucher.length > 0">
                        <b-col class="small">Comprovante de Pagamento</b-col>
                    </b-row>
                    <b-row v-show="row.item.paymentVoucher && row.item.paymentVoucher.length > 0">
                        <b-col class="text-primary">{{ row.item.paymentVoucher }}</b-col>
                    </b-row>
                    <b-row v-show="row.item.notes && row.item.note != ''">
                        <b-col class="small">Observação</b-col>
                    </b-row>

                    <b-row v-show="row.item.notes && row.item.note != ''">
                        <b-col class="text-primary">{{ row.item.notes }}</b-col>
                    </b-row>

                </b-card>
            </template>

            <template v-slot:cell(attachment)="data">
                <b-button v-show="data.item.fileUrl" size="sm" variant="primary" class="mr-1 btn-brand" @click="openDocumentModal(data.item)"><i class="fa fa-file-o"></i></b-button>
            </template>
            
            <template v-slot:cell(itemDiscount)="data">
                <b-form-input
                type="number"
                v-model.number="data.item.discount"
                readonly
                ></b-form-input>
            </template>

            <template v-slot:cell(paymentDate)="data">
                {{ $utils.localDate(data.item.paymentDate) }}
            </template>


            <template v-slot:cell(totalValue)="data">
                R$ {{ $utils.numberFormat(data.item.totalValue) }}
            </template>

            <template v-slot:cell(action)="data">
                <b-button size="sm" variant="danger" @click="deleteItem(data.item)" class="mr-1 btn-brand"><i class="fa fa-times"></i></b-button>                  
            </template>

        </b-table>

        <hr>
        
        <b-row>
          <b-col md="12">
            <b-form>
              <b-form-group
              description=""
              label="Vencimento:"
              label-for="dueDate"
              :label-cols="3"
              :horizontal="true">
              <b-row>
                <b-col>
                    {{ $utils.localDate(item.dueDate) }}
                </b-col>
                <b-col sm="auto">
                  Total:
                </b-col>
                <b-col class="text-right">
                    <b>R$ {{ $utils.numberFormat(totalAccount)  }}</b>
                </b-col>
              </b-row>              
            </b-form-group>          
            </b-form>
          </b-col>
        </b-row>

       
        <b-row>
          <b-col md="12">
            <b-form>
              <b-form-group
              description=""
              label="Valor:"
              label-for=""
              :label-cols="3"
              :horizontal="true">
              <b-row>
                <b-col>
                    R$ {{ $utils.numberFormat(this.item.totalValue) }}
                </b-col>
                <b-col sm="auto">
                    Valor pago:
                </b-col>
                <b-col class="text-right">
                    R$ {{ $utils.numberFormat(this.paymentValue)  }}
                </b-col>
              </b-row>

            </b-form-group>          
            </b-form>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form>
              <b-form-group
              description=""
              label="Juros:"
              label-for=""
              :label-cols="3"
              :horizontal="true">
              <b-row>
                <b-col>
                    <p class="text-danger">R$ {{ $utils.numberFormat(this.item.fees) }}</p>
                </b-col>
                <b-col sm="auto">
                    Total a Pagar:
                </b-col>
                <b-col class="text-right">
                    <b class="text-danger">R$ {{ $utils.numberFormat(totalToPay)  }}</b>
                </b-col>
              </b-row>
              
            </b-form-group>          
            </b-form>
          </b-col>
        </b-row>
  
        <b-modal v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Pagamento"
              size="md">
              
              <payment-component 
                :item="currentAccount"
                :accountType="accountType"
                :companyId="companyId"
                @item-selected="handleSelectedPayment"
              ></payment-component>
           
        </b-modal>


        <b-modal title="Comprovante de Pagamento" class="modal-danger" v-model="documentModal" @ok="documentModal = false" ok-variant="danger" hide-footer size="xl" v-if="selectedDocument">
          <div class="ratio ratio-16x9">        
              <iframe
              :src="this.selectedDocument.fileUrl"
              allowfullscreen
              width="100%"
              height="600px"
              ></iframe>
          </div>
      </b-modal>

        
    </div>
</template>


<script>
import Vue from 'vue'
import axios from "axios";

import PaymentComponent from './PaymentComponent'

export default {
    name: 'paymentGridComponent',
    props: {
        item: {},
        accountType: String,
        companyId: String
    },
    components: {
        PaymentComponent
    },
    data: () => {
        return {
            selectedDocument: null,
            paymentValue: 0,

            editModal: false,
            items: [],
            table: {
                fields: [
                    {key: 'show_details', label: "", thStyle: { width: "30px" } },
                    { key: 'paymentDate', label: 'Data do Pagamento', sortable: true },
                    { key: 'totalValue', label: 'Valor', thStyle: { width: "120px" }, tdClass: 'text-right' },
                    //{ key: 'quantity', label: 'Quantidade', thStyle: { width: "120px" } },
                    //{ key: 'itemDiscount', label: 'Desconto', sortable: false, thStyle: { width: "120px" } },
                    //{ key: 'totalValue', label: 'Valor Total', thStyle: { width: "120px" }, tdClass: 'text-right' }
                    //{ key: 'description', label: 'Descrição', sortable: true},
                    //{ key: 'action2', label: '', sortable: false, thStyle: { width: "40px" } },                    
                    {key: 'attachment', label: "", thStyle: { width: "25px" } },
                    
                ],
                selectMode: 'single',
                isBusy: false,
                primaryKey: "id",
                transProps: {
                    name: 'flip-list'
                }

            },
            
        }
    },
    computed: {
        currentAccount() {
            return this.item
        },
        totalAccount() {
            var total = this.item.totalValue
            if(this.item.fees)
               total = total + this.item.fees
            if(this.item.discount)
               total = total = this.item.discount
            return total
        },
        totalToPay() {
            var total = this.totalAccount
            if(this.paymentValue)
               total = total - this.paymentValue
            return total

        },
        diffValue() {
          
          var diff = this.totalToPay
          if(this.paymentValue)
            diff = diff - this.paymentValue
            // (this.accountTotalValue ? this.accountTotalValue : 0) - (this.paymentValue ? this.paymentValue : 0)
          this.$emit("diff-changed", diff)

          return diff
       }
    },
    methods: {

        async deleteItem(item) {
            var s = this;
            var currentUser = this.$store.state.currentUser;

            var url = this.$store.state.ws_url + "/finance/ap/payment?accountId=" + item.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            if(s.accountType == 'R') {
                url = this.$store.state.ws_url + "/finance/ar/payment?accountId=" + item.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            }
            await axios.delete(
                url
            ).then(function(resp) {
                s.refreshData()
            }).catch(function(error) {
                console.log(error)
            })

        },
        openDocumentModal(item) {
            this.selectedDocument = item;
            this.documentModal=true;
        },
        openModal() {
            this.editModal = true
        },
        closeModal() {
            this.editModal = false
        },
        
        handleSelectedPayment(obj) {
            this.closeModal();
            this.refreshData();
        },

        getPaymentsTotal() {
            if(this.items) {
                var total = 0
                this.items.forEach((item) => {
                    total = total + (item.totalValue ? item.totalValue : 0)
                })
                this.paymentValue = total
            }
            else {
                this.paymentValue = 0
            }
            
            this.currentAccount.paymentValue = this.paymentValue
            return this.paymentValue
        },
        
        async getPayments() {
            var s = this;
            if(s.currentAccount && s.currentAccount.id) {
                var currentUser = this.$store.state.currentUser;
                var url = this.$store.state.ws_url + "/finance/ap/payment?accountId=" + s.currentAccount.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
                if(s.accountType == 'R') {
                    url = this.$store.state.ws_url + "/finance/ar/payment?accountId=" + s.currentAccount.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
                }

                await axios.get(
                    url
                ).then(function(resp) {
                    s.items = resp.data.obj;
                    s.getPaymentsTotal();

                }).catch(function (error) {
                    console.log(error);
                    s.items = []
                });
            }
            
        },

        refreshData() {
            this.getPayments()
        }
    },
    mounted: function() {
        this.refreshData()
    }

}

</script>